import type { Theme, Components } from '@mui/material/styles'
import { varAlpha } from 'minimal-shared/utils'

// --------------------------------------------------------------------------------------------- //

const MuiBackdrop: Components<Theme>['MuiBackdrop'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      //  backgroundColor: varAlpha(theme.vars.palette.grey['800Channel'], 0.48) // this is the default mui one
      backgroundColor: varAlpha(theme.vars.palette.grey['800Channel'], 0.7) // this is mine that i had before...
    }),
    invisible: { background: 'transparent' }
  }
}

// --------------------------------------------------------------------------------------------- //

export const backdrop = { MuiBackdrop }
